"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { SpaceXs, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { MarketingTypography } from "../../MarketingTypography/index.js";
import { FillImage } from "../styles.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const MarkdownWithInlineImages = ({
  imagePlacement,
  headerConfig,
  headerContent
}) => {
  const renderedInlineImages = [];
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        display: "flex",
        flexBasis: `calc(${100 - imagePlacement}% - 56px)`,
        flexGrow: 1,
        flexWrap: "wrap",
        textAlign: headerConfig.content_alignment
      },
      children: headerContent.map((item, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
        if (item.markdown_text) {
          const hasNextInlineImages = [];
          for (let i = index + 1; i < headerContent.length; i++) {
            if (headerContent[i].inline_image) {
              hasNextInlineImages.push(headerContent[i]);
              renderedInlineImages.push(i);
            } else {
              break;
            }
          }
          return /* @__PURE__ */ jsxs(
            CostcoBox,
            {
              sx: {
                display: "flex",
                flexBasis: "100%",
                flexWrap: "wrap",
                justifyContent: headerConfig.content_alignment,
                marginBottom: index !== headerContent.length - 1 && SpaceXs
              },
              children: [
                /* @__PURE__ */ jsx(
                  MarketingTypography,
                  {
                    sx: {
                      color: (_c = (_b = (_a = item == null ? void 0 : item.markdown_text) == null ? void 0 : _a.color) == null ? void 0 : _b.text_color) == null ? void 0 : _c.hex
                    },
                    component: (_d = item == null ? void 0 : item.markdown_text) == null ? void 0 : _d.select_semantics_type,
                    isMarkdown: true,
                    uniqueId: `programcard_header_markdown_${index}`,
                    variant: (_e = item == null ? void 0 : item.markdown_text) == null ? void 0 : _e.select_text_type,
                    children: (_f = item == null ? void 0 : item.markdown_text) == null ? void 0 : _f.markdown_text
                  },
                  `markdown_text_${index}`
                ),
                hasNextInlineImages.map(
                  (inlineImage, inlineImageIndex) => {
                    var _a2, _b2, _c2;
                    return /* @__PURE__ */ jsx(
                      CostcoBox,
                      {
                        children: /* @__PURE__ */ jsx(
                          FillImage,
                          {
                            alt: (_a2 = inlineImage == null ? void 0 : inlineImage.inline_image) == null ? void 0 : _a2.image_alt_text,
                            src: (_c2 = (_b2 = inlineImage == null ? void 0 : inlineImage.inline_image) == null ? void 0 : _b2.image[0]) == null ? void 0 : _c2.url,
                            loading: "lazy",
                            sx: { paddingLeft: SpaceXxs }
                          }
                        )
                      },
                      `markdown_inline_image_${inlineImageIndex}`
                    );
                  }
                )
              ]
            },
            `header_content_${index}`
          );
        } else if (!renderedInlineImages.includes(index) && !!item.inline_image) {
          return /* @__PURE__ */ jsx(
            CostcoBox,
            {
              sx: {
                width: "max-content"
              },
              children: /* @__PURE__ */ jsx(
                FillImage,
                {
                  src: (_i = (_h = (_g = item == null ? void 0 : item.inline_image) == null ? void 0 : _g.image) == null ? void 0 : _h[0]) == null ? void 0 : _i.url,
                  alt: (_j = item == null ? void 0 : item.inline_image) == null ? void 0 : _j.image_alt_text,
                  loading: "lazy"
                }
              )
            },
            `header_content_${index}`
          );
        }
      })
    }
  );
};
export {
  MarkdownWithInlineImages
};
